"use strict";

exports.__esModule = true;
exports.getDominantPol = void 0;
/**
 * From some normalized data, calculate the dominant pollutant, i.e. the
 * pollutant that has the highest AQI
 *
 * @param normalized - The normalized data
 */

function getDominantPol(normalized) {
  return normalized.slice(-1).sort(function (a, b) {
    return a.value - b.value;
  })[0].parameter;
}

exports.getDominantPol = getDominantPol;